import React from "react";
import PropTypes from "prop-types";
import { Helmet } from "react-helmet";
import { useStaticQuery, graphql } from "gatsby";

//const SEO = ({ schema, lang, meta, title, canonical }) => {
const SEO = (props) => {
  const { site } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            title
            description
            applicationName
            siteUrl
          }
        }
      }
    `
  );
  //To do: similar to og image set default meta tags and allow it to be overridden from page
  let hasOgImage = false,
    hasOgWidth = false,
    hasOgHeight = false,
    _meta = Array.from(props.meta);
  //To do: get 1200*630 size wafd logo image from UX team
  const metaData = _meta.map((metaTag) => {
    switch (metaTag.property) {
      case "og:image": {
        hasOgImage = true;
        metaTag.content = metaTag.content || `${site.siteMetadata.siteUrl}/images/wafd-logo.png`;
        return { ...metaTag };
      }
      case "og:image:width": {
        hasOgWidth = true;
        metaTag.content = metaTag.content || "1200";
        return { ...metaTag };
      }
      case "og:image:height": {
        hasOgHeight = true;
        metaTag.content = metaTag.content || "630";
        return { ...metaTag };
      }
      default:
        return { ...metaTag };
    }
  });
  if (!hasOgImage) {
    metaData.push({
      property: "og:image",
      content: `${site.siteMetadata.siteUrl}/images/wafd-logo.png`
    });
  }
  if (!hasOgWidth) {
    metaData.push({
      property: "og:image:width",
      content: "1200" // TODO: this value seems very large for our PNG logo.
    });
  }
  if (!hasOgHeight) {
    metaData.push({
      property: "og:image:height",
      content: "630" // TODO: this value seems very large for our PNG logo.
    });
  }

  let pageTitle = props.title; // props.wafdBankTitlePosition == "none"
  if (props.wafdBankTitlePosition == "right") {
    pageTitle = pageTitle + " | " + site.siteMetadata.title;
  } else if (props.wafdBankTitlePosition == "left") {
    pageTitle = site.siteMetadata.title + " | " + pageTitle;
  }

  return (
    <Helmet
      htmlAttributes={{ lang: props.lang }}
      defaultTitle={site.siteMetadata.title}
      title={pageTitle}
      link={props.alternate ?? []}
      meta={metaData}
    >
      {Object.keys(props.schema).length !== 0 && (
        <script type="application/ld+json">{JSON.stringify(props.schema)}</script>
      )}
    </Helmet>
  );
};

SEO.defaultProps = {
  lang: `en`,
  meta: [],
  title: "",
  schema: {},
  wafdBankTitlePosition: "right" // "left", "right", or "none"
};

SEO.propTypes = {
  lang: PropTypes.string,
  alternate: PropTypes.arrayOf(PropTypes.object),
  meta: PropTypes.arrayOf(PropTypes.object),
  title: PropTypes.string.isRequired,
  schema: PropTypes.object,
  wafdBankTitlePosition: PropTypes.string
};

export default SEO;
